<template>
    <div>
        <span  @click="getAllpfList" style="color:blue;cursor: pointer;font-size:13px;">【点击刷新】</span>
        <vggrid  :random="Math.floor(Math.random() * 999999)" :list="psuList" tableheight="600" flexname="" :cols="cols"
                :canbeEdit="iscanbeEdit"
                :showfooter="false" :showPage="false" :resizable="true"
                :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
        >
        </vggrid>
        <div class="btn">
          <div>
            <el-button type='primary' style="width:200px;" v-if="+project.projectqcheckflg !== 1" @click="saveSeq">提交</el-button>
          </div>
        </div>
    </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'

  export default {
    name: 'exPqcCheckSum',
    components: {vggrid},
    props:{
        activeName: {}
    },
    deactivated () {
      this.$destroy()
    },
    data () {
      return {
        project: {},
        psuList: [],
        pqcesList:[],
        pexpertInfo:{},
        pexertList:[],
        btnLoading: false,
        model: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        cols: [
          {field: 'comfullname', fieldtype: 'I', title: '供应商', calculExpr: ''},
          // {field: 'psas', fieldtype: 'I', title: '最终得分', calculExpr: ''},
          // {field: 'psseq', fieldtype: 'I', title: '排名', calculExpr: ''},
          // {field: 'psdesc', fieldtype: 'I', title: '意见', calculExpr: '', editRender: { name: 'input'}}
        ],
        iscanbeEdit:true
      }
    },
    created () {
      this.getModel()
      this.getAllpfList()
      this.getPexertInfo()
    },
    activated(){
      this.getModel()
    },
    mounted(){
    },
    watch:{
      activeName () {
        console.log(this.activeName)
        if(this.activeName === 'cshz') {
            this.getModel()
        }
      }
    },
    methods: {
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
      },
      async getAllpfList(){
        this.cols = [
          {field: 'comfullname', fieldtype: 'I', title: '供应商', calculExpr: ''}
        ]
        let data = await request({
          method: 'get',
          url: 'expert/getAllpfList',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.psuList = data.psuList
        this.pqcesList = data.pqcesList
        this.pexertList = data.pexertList
        this.setCrossCols(data)
        this.totalScore(this.pqcesList)
      },
      async getPexertInfo () {
        let res = await request({
          method: 'get',
          url: 'expert/getPexertInfo',
          params: {pexpertid: this.$store.getters.expertLoginUser.pexpertid}
        })
        this.pexpertInfo = res
        if(this.pexpertInfo.pexpertmobile == null){
            this.$message.warning('请先填写评审人资料')
            this.$router.push({name: 'pExpertIndex', params: {}})
            return
        }
      },
      async setCrossCols(res){
          if(res.pexertList.length > 0){
            for(let i = 0;i < res.pexertList.length;i++){
              let item = res.pexertList[i]
              this.cols.push({
                  title:item.pexpertname ==  null?item.pexpertlogincode:item.pexpertname,
                  slots: {
                  default: 'default',
                  default: ({row}) => {
                    return this.getCrossCheckResultDesc({pexpertid:item.pexpertid,psucomid:row.psucomid})
                  }
                }
              })
            }
          }
          // this.cols.push({field: 'psupqcesresult',syscode:'psupqcesresult',fieldtype: 'C', title: '汇总结果', calculExpr: '',editRender: { name: 'select', options: []}})
          this.cols.push({
                  title: '汇总结果',
                  slots: {
                  default: 'default',
                  default: ({row}) => {
                      if(+row.psupqcesresult === 1){
                        return '通过'
                      }
                      if(+row.psupqcesresult === 2){
                        return '不通过'
                      }
                      else{
                        return '未评审'
                      }
                  }
                }})
          this.cols.push({
                  title: '意见',
                  slots: {
                  default: 'default',
                  default: ({row}) => {
                    if(this.iscanbeEdit)
                      return [<el-input v-model={row.psupqcescdesc}></el-input>]
                    else
                      return row.psupqcescdesc
                  }
                }})
      },
      getCrossCheckResultDesc(item){
          let code = this.pqcesList.filter(v => +v.pqcesexpertid === +item.pexpertid && +v.pqcescomid === +item.psucomid)
          let i = code.length > 0 ? code[0].pqcesresultdesc:''
          return i
      },
      totalScore(e){
        let ty = 0,bty = 0;
        for(let i=0;i < this.psuList.length;i++){
          if(this.psuList[i].psupqcesresult != null){
            this.iscanbeEdit = false
          }
        }
        for(let i = 0;i < this.psuList.length; i++){
          let sum = 0
          for(let j = 0;j <this.pqcesList.length; j++){
              if(this.psuList[i].psucomid === this.pqcesList[j].pqcescomid){
                if(+this.pqcesList[j].pqcesresult === 1){
                    ty++
                }
                if(+this.pqcesList[j].pqcesresult === 2){
                    bty++
                }
              }
          }
          // if(ty > bty){
          //   this.psuList[i].psupqcesresult = '1'
          // }
          if(bty === 0 && ty === 0){
            this.psuList[i].psupqcesresult = '3'
          }
          else if(bty > 0){
            this.psuList[i].psupqcesresult = '2'
          }
          else
            this.psuList[i].psupqcesresult = '1'
          ty = 0,bty = 0
        }
      },
      async getpsrecList(){
        let prsList = await request({
          method: 'get',
          url: 'expert/getpsrecList',
          params:{psprojectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })

        if(prsList.length>0){
          this.iscanbeEdit = false
          this.psuList.forEach(e => {
              e.psdesc = prsList.filter(v => +v.pscomid === +e.psucomid && +v.psprojectid === +e.psuprojectid)[0].psdesc
          });
        }
      },
      async saveSeq(){
        if(this.pqcesList.length < this.pexertList.length * this.psuList.length){
              this.$message.warning('还有评审人未评审！')
              return
        }
        this.loading = true
        this.$confirm('提交后不能再修改', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(async() => {
            this.psuList.forEach(e=>e.psexpertid = this.$store.getters.expertLoginUser.pexpertid)
            let data = await request({
              method: 'post',
              url: 'expert/saveResult',
              data:{
                psuList: this.psuList,
                projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
                pexpertid: this.$store.getters.expertLoginUser.pexpertid,
                projectpgstotalrule: this.project.projectpgstotalrule,
                projectpricecomputebasis: this.project.projectpricecomputebasis,
                projectpricecomputebasisdesc: this.project.projectpricecomputebasisdesc
              }
            })
            if(data.issuccess === 1){
              this.$message.success('提交成功')
              this.getModel()
              this.totalScore(this.pqcesList)
            }
        })
        this.loading = false
      },
      async cellClick (row) {
        this.model = row
      },
      async viewProject(row) {
        this.model = row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      }

    }
  }
</script>

<style lang="scss" scoped>
.btn{
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 30px 0;
}
</style>